import Icon from '@mui/icons-material/AssessmentRounded';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function ChartIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
